import { render } from "./AppFooter.vue?vue&type=template&id=1d039594"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=1d039594&lang=scss"

import exportComponent from "/Users/lucas/Web/_loco/theadccawards/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__